// สถานะการอนุรักษ์ของ IUCN (docs/PLAN.md ข้อ 2)

export type IucnCode = "EX" | "EW" | "CR" | "EN" | "VU" | "NT" | "LC" | "DD" | "NE";

export const IUCN_TH: Record<IucnCode, string> = {
  EX: "สูญพันธุ์",
  EW: "สูญพันธุ์ในธรรมชาติ",
  CR: "ใกล้สูญพันธุ์อย่างยิ่ง",
  EN: "ใกล้สูญพันธุ์",
  VU: "มีแนวโน้มใกล้สูญพันธุ์",
  NT: "ใกล้ถูกคุกคาม",
  LC: "ความกังวลน้อยที่สุด",
  DD: "ข้อมูลไม่เพียงพอ",
  NE: "ยังไม่ได้ประเมิน",
};

export const THREATENED: ReadonlySet<IucnCode> = new Set<IucnCode>(["CR", "EN", "VU"]);

export function isIucnCode(value: unknown): value is IucnCode {
  return typeof value === "string" && value in IUCN_TH;
}
